import { Component, OnInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { opacityAnimation } from 'src/app/Animations/opacity.animation';
import { PerguntaService } from 'src/app/Services/pergunta.service';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { DynamicScriptLoaderService } from 'src/app/Services/dynamic-script-loader.service';
declare var $: any;

@Component({
  selector: 'ppa-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [opacityAnimation]
})
export class HomeComponent implements OnInit {
  @HostBinding('@load') animacao = 'carregado';

  private perguntaId: number;

  constructor(private roteamento: Router,
    private rotaAtiva: ActivatedRoute,
    private perguntaService: PerguntaService,
    private toastr: ToastrService) { }

  ngOnInit() {
  }

  //Revisar: Lógica pode mudar conforme retorno da API.
  obterPerguntas(areaParticipanteId: number) {
      var ListaIds: number[];
      var ListaIdsStr: string = null;
      this.perguntaService.obterIDsPerguntas(areaParticipanteId)
      .subscribe((response: number[]) => { 
        if (response){
          ListaIds = response;
          
          ListaIds.map(function(value) {
            if (ListaIdsStr == null)
              ListaIdsStr = String(value);
            else
              ListaIdsStr = ListaIdsStr + ',' + String(value);
            return String(value);
          });
          
        }
      }, () => {
        console.log('Houve um erro ao recuperar as perguntas');
      }, () => {
        if(ListaIdsStr){
          this.roteamento.navigate(['area-participacao', areaParticipanteId, 'perguntas', ListaIdsStr],
          { relativeTo: this.rotaAtiva });
        }
      });
  }

  ngAfterViewInit(): void {
    $(document).ready(function () {
      $('map').imageMapResize();
    });
  }
}
